module.exports = __webpack_public_path__ + "advisory-8c397925/test-d1019e1375a192875cb58ab3ecf53ad1.jpeg";